export default {
  data() {
    return {
      user: {
        targetCss: {
          color: "",
          bgMod: "",
          genericMod: "",
          bgClass: "",
          target: "",
          headerClass: "",
          colorMod: "",
          borderMod: "",
        },
      },
    };
  },
  mounted() {
    this.setupUser();
  },
  beforeDestroy() {
    this.disableEvent();
  },
  methods: {
    setUserFromEvent(event) {
      // eslint-disable-next-line prefer-destructuring
      if (Array.isArray(event.detail)) [this.user] = event.detail;
      else this.user = event.detail;
    },
    setupUser() {
      if (window.deaHeader && window.deaHeader.user) {
        this.user = { ...this.user, ...window.deaHeader.user };
      }
      document.querySelector("dea-top-header").addEventListener("update-user", this.setUserFromEvent);
    },
    disableEvent() {
      document.querySelector("dea-top-header").removeEventListener("update-user", this.setUserFromEvent);
    },
  },
};
